import { CircularProgress, styled } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { ReactComponent as RoleIcon } from "../../../../svg/adminRoleIcon.svg";
import { ReactComponent as Arrow } from "../../../../svg/arrow.svg";
import { ReactComponent as DeleteIcon } from "../../../../svg/deleteIcon.svg";
import apiCall from "../../../../utils/apiCall";
import SettingsModal from "../SettingsModal/settingsModal";
import EditCertificateScore from "./editScoreSetUp";
import DeleteScoreContent from "./deleteScoreContent";
import ViewScoreContent from "./viewScoreContent";
import { ReactComponent as World } from '../../../../svg/world.svg';
import CreateScoreContent from "./createScoreSetUpContent";
import { AxiosError } from "axios";
import {RouteResponse} from '../../../../types/index';
import {FetchAllRoutes, reOrderFetchedData, filterRouteName} from '../../../../hooks/FetchData';

interface ButtonProp {
  handleClick: () => void;
}

interface AllScoreData {
  Id: number;
  RouteId: number;
  ScoreTypeId: number;
  MinYears: number;
  MaxYears: number;
  Years: number;
  Score: number;
  ActiveStatus: boolean;
}

const ScoreSetup: React.FC<ButtonProp> = ({ handleClick }) => {
    const [id, setId] = useState(0);
    const [score, setScore] = useState(0);
    const [scoretype ,setScoreType] = useState(''||0);
    const [routeId, setRouteId] = useState<number>(0);
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [minYears, setMinYears] = useState<number>(0);
    const [maxYears, setMaxYears] = useState<number>(0);
    const [years, setYears] = useState<number>();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openRoleModal, setOpenRoleModal] = useState(false);
    const [openCard, setOpenCard] = useState(false);

    const {data: allRoutesData} = FetchAllRoutes();
    const reOrderedAllRoutes = allRoutesData ? reOrderFetchedData((allRoutesData as RouteResponse )?.Data) : []
  
    const handleOpenCreateModal = () => setOpenCreateModal(true);
    const handleCloseCreateModal = () => setOpenCreateModal(false);
  
    const handleOpenEditModal = () => setOpenEditModal(true);
    const handleCloseEditModal = () => setOpenEditModal(false);
  
    const handleOpenDeleteModal = () => setOpenDeleteModal(true);
    const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  
    const handleOpenRoleModal = () => setOpenRoleModal(true);
    const handleCloseRoleModal = () => setOpenRoleModal(false);
  
    const handleCard = () => setOpenCard(!openCard);
  
    const handleRole = () => {
      setOpenCard(false);
      handleCloseRoleModal();
    };
  
    const handleDisable = () => {
      handleCloseRoleModal();
      setOpenCard(false);
      handleOpenDeleteModal();
    };
  
    const handleEdit = () => {
      handleCloseRoleModal();
      setOpenCard(false);
      handleOpenEditModal();
    };

    const handleOpen = (setupscore: AllScoreData) => {
      setId(setupscore?.Id)
      setScore(setupscore?.Score)
      setScoreType(setupscore?.ScoreTypeId)
      setRouteId(setupscore?.RouteId)
      setMaxYears(setupscore?.MaxYears);
      setMinYears(setupscore?.MinYears);
      handleOpenRoleModal();
    }
    
  const GetAllScore = async (): Promise<any> => {
    return await apiCall().get(`/SetUp/GetAllCoreHRScore`);
  };

  const { data, isLoading, isError, error } = useQuery(
    ["get-AllCoreHrScore"],
    GetAllScore,
    {
      keepPreviousData: true,
      retry: 0,
      enabled: true
    }
  );

  const scoreSetupError = error as AxiosError;
  const scoreSetupErrorMessage = scoreSetupError?.message;

  return (
    <>
    {isLoading ? (
      <CircularProgress 
        sx={{
          fontSize: '1rem',
          marginInline: 'auto',
          display: 'block',
          marginBlock: '2rem'
        }}
      />
    ) : isError ? (
      <StyledError>{scoreSetupErrorMessage}</StyledError>
    ) : (
      <StyledContainer>
        <TotalWrapper>
          <span>Total</span>
          <TotalNumberStyle>{data?.data?.Data.length}</TotalNumberStyle>
        </TotalWrapper>
        {data?.data?.Data &&
        data?.data?.Data.length > 0 &&
        data?.data?.Data.map((data: AllScoreData) => (
          <RoleWrapper onClick={() => handleOpen(data)} key={data.ScoreTypeId}>
            <div>
              <RoleIconWrapper>
                <RoleIcon />
              </RoleIconWrapper>
              <RoleText>{`Core Hr SetUp (${filterRouteName(data.RouteId, reOrderedAllRoutes)})`}</RoleText>
              <Active>{`Score ${data.Score}`}</Active>
              <DateWrapper>{`Between ${data.MaxYears} years and ${data.MinYears}`}</DateWrapper>
            </div>
          
            <ArrowIconWrapper>
              <Arrow />
            </ArrowIconWrapper>
          </RoleWrapper>
        ))}

        <SettingsModal
          header={'Core Hr Score Set Up'}
          open={openRoleModal}
          maxWidth={"712px"}
          content={<ViewScoreContent MinYears={minYears} MaxYears={maxYears} RouteId={routeId} Score={score}  ScoreTypeId={scoretype}/>}
          cancel={setOpenRoleModal}
          showrightIcon={true}
          worldIcon={<World/>}
          card={
            <>
              <CardItems onClick={handleEdit}>Update</CardItems>
              <CardItems onClick={handleDisable}>Delete</CardItems>
            </>
          }
        />
        <SettingsModal
          header="Update Core Hr Score SetUp"
          open={openEditModal}
          maxWidth={"480px"}
          content={<EditCertificateScore handleClose={handleCloseEditModal} MinYears={minYears} MaxYears={maxYears} RouteId={routeId} Score={score} ScoreId={id} ScoreTypeId={scoretype} />}
          cancel={setOpenEditModal}
          showrightIcon={false}
          worldIcon={<World/>}
        />
   
        <SettingsModal
          header="Delete Core Hr Score SetUp"
          open={openDeleteModal}
          maxWidth={"536px"}
          content={<DeleteScoreContent 
            Score={score} 
            description={'Name'} 
            ScoreId={id} 
            handleClose={handleCloseDeleteModal} 
          />}
          cancel={setOpenDeleteModal}
          showrightIcon={false}
          worldIcon={<DeleteIcon/>}
        />
      </StyledContainer>
    )}
    
    </>
  );
};

export default ScoreSetup;

const StyledContainer = styled("div")`
  margin-block: 3.8rem;
  margin-inline: 3.5rem;
`;

const TotalNumberStyle = styled("span")`
  background-color: #f1f3f4;
  border-radius: 0.2rem;
  margin-inline-start: 0.4rem;
  padding-inline: 0.2rem;
`;

const TotalWrapper = styled("div")`
  color: #4e5a62;
  font-weight: 500;
`;

const RoleWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  border: 0.1rem solid #e1e1e1;
  margin-block: 0.6rem;
  padding-inline: 1.2rem;
  padding-block: 1.2rem;
  border-radius: 0.5rem;
  width: 100%;
  text-align: left;
  background-color: transparent;
`;

const RoleIconWrapper = styled("span")`
  background-color: #fff4de;
  border-radius: 0.1rem;
  padding-inline: 0.4rem;
`;

const RoleText = styled("span")`
  font-weight: 600;
  font-size: 16px;
  margin-inline: 0.8rem;
`;

const Active = styled("span")`
  font-size: 14px;
  font-weight: 500;
  background-color: #e0faee;
  border-radius: 0.4rem;
  padding-inline: 0.5rem;
  color: #11643c;
`;

const DateWrapper = styled("div")`
  margin-block-start: 0.8rem;
  font-size: 14px;
`;

const ArrowIconWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const CardItems = styled(`div`)`
  height: 41px;
  background: #FFFFFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-inline-start: 23px;

  &:hover {
    background: #F1F1F1;
  }

`

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`